<!--活动弹出框-->
<template>
  <div class="activityBox" v-if="row.show">
    <div class="activity-box">
      <img class="activity-img" src="https://static.dierqudao.com/images/bg-goods-activity.png" />
      <div class="activity-goods-detail">
        <img class="activity-goods-img" :src="row.pic_url" />
        <div class="activity-goods-title-box">
          <div class="ac-goods-title">{{row.title}}</div>
          <div class="ac-title">
            <div class="ac-name" :style="'background:'+row.color">{{row.tag}}</div>
            <div>{{row.desc}}</div>
          </div>
        </div>
      </div>
      <div class="activity-join">
        <div class="activity-count-down">
          <div>活动倒计时&nbsp;</div>
          <div class="count-down">
            <van-count-down :time="(row.last_time+1)*1000">
              <template v-slot="timeData">
                <span class="item">{{ timeData.days }}</span>天
                <span class="item">{{ timeData.hours }}</span>
                <span class="sign">:</span>
                <span class="item">{{ timeData.minutes }}</span>
                <span class="sign">:</span>
                <span class="item">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
        <div class="activity-join-btn">
          <div @click="goTuanDetail(row.url)">立即参加</div>
        </div>
      </div>
      <div class="ac-close" @click="closeActivity">
        <img class="ac-close-img" src="https://static.dierqudao.com/images/icon-close@2x.png" />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "ActivityDialog",
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data() {
    return {
      timeData: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      }
    };
  },

  mounted: function() {
    this.lastTimeRun();
  },
  methods: {
    closeActivity() {
      this.row.show = false;
    },

    lastTimeRun() {
      let that = this;
      let lastTime_t_handle = setInterval(() => {
        that.timeData = that.lastTime(that.row.last_time);

        if (that.row.last_time == 0) {
          clearInterval(lastTime_t_handle);
          return;
        }
        that.row.last_time -= 1;
      }, 1000);
    },

    goTuanDetail(url) {
      rbLink({
        name: url.name.substring(0, 1).toUpperCase() + url.name.substring(1),
        query: { id: url.query.id }
      });
     
    }
  }
};
</script>
<style scope>
.van-count-down {
  color: #000;
  display: flex;
  line-height: 16px;
}
.activityBox {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  background: rgba(8, 8, 8, 0.5);
  z-index: 8;
}

.activity-box {
  width: 100%;
  text-align: center;
  position: fixed;
  top: 45px;
}

.activity-img {
  /*width: 350px;*/
  /*height: 400px;*/
  height: 8rem;
}

.activity-goods-detail {
  margin: 0 auto;
  /*width: 230px;*/
  width: 4.5rem;
  display: flex;
  position: relative;
  /*top: -250px;*/
  top: -5rem;
  justify-content: space-between;
}

.activity-goods-img {
  height: 70px;
  width: 70px;
}

.activity-goods-title-box {
  width: 150px;
  height: 70px;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: space-between;
}

.ac-goods-title {
  width: 150px;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 15px;
}

.ac-name {
  display: inline-block;
  width: 17px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 17px;
  border-radius: 3.5px;
  text-align: center;
  margin-right: 5px;
}

.ac-title {
  height: 17px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  display: flex;
}

.activity-join {
  position: relative;
  top: -200px;
}

.activity-count-down {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  color: #000;
}

.activity-join-btn {
  margin: 22.5px auto;
  width: 194px;
  height: 45px;
  height: 45px;
  border-radius: 45px;
  border-radius: 45px;
  background: yellow;
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  line-height: 45px;
  line-height: 45px;
  letter-spacing: 2.5px;
  overflow: hidden;
}

.activity-join {
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}

.count-down span.item {
  /*height: 16px;
        background: #000;
        color: #fff;
        font-size: 14px;
        display: inline-block*/

  font-size: 14px;
  background: #000000;
  color: #fff;
  display: block;
  width: 16px;
  height: 16px;
}

.count-down span.sign {
  display: block;
  width: 16px;
  height: 16px;
  color: #000;
  font-weight: 700;
}

.ac-close {
  height: 30px;
  width: 30px;
  position: relative;
  top: -50px;
  margin: 0 auto;
}

.ac-close-img {
  height: 30px;
  width: 30px;
}
</style>





// WEBPACK FOOTER //
// ActivityDialog.vue?e528a208